import { z } from "zod/v4";

type ExpressionNodeLike = {
  query?: {
    type: string;
    value?: unknown;
  };
};

type CartTargetingLike = {
  expression?: ExpressionNodeLike[];
};

export const cartTargetingRefinements = {
  expressionQueriesHaveTypeOrValue: <T extends CartTargetingLike>(ct: T) => {
    if (!ct.expression) {
      return true;
    }
    return ct.expression.every((node) => {
      if (!node.query) {
        return true;
      }
      return (
        node.query.type === "anything" ||
        node.query.type === "subscription" ||
        node.query.value !== undefined
      );
    });
  },
};

export const cartTargetingRefinementMessages = {
  expressionQueriesHaveTypeOrValue:
    "Cart targeting expression queries must have 'anything' type or a value",
};

export function applyCartTargetingRefinements<
  S extends z.ZodType<CartTargetingLike>,
>(schema: S) {
  return schema.refine(
    (ct) =>
      cartTargetingRefinements.expressionQueriesHaveTypeOrValue(
        ct as CartTargetingLike
      ),
    {
      error: cartTargetingRefinementMessages.expressionQueriesHaveTypeOrValue,
    }
  );
}
